module.exports = __webpack_public_path__ + "static/media/meetingLocation.0756a9d7.svg";